import React from 'react'

import { OnSchedUtils } from '../../../utils';
import { GetCountries, GetStates } from '../../../actions/locationActions';


const StateCountry = (e) => {
  const colorClasses = 'onsched-border-border-color onsched-dark-color onsched-primary-border-color-hover onsched-primary-border-color-active onsched-primary-border-color-focus';
  const transparentClasses = 'onsched-border-border-color onsched-dark-color';
  const [countries, setCountries] = React.useState([]);
  const [states, setStates] = React.useState([]);
  const [statesClass, setStatesClass] = React.useState("");

  React.useEffect(() => { GetCountries(e.element).then(setCountries) }, []);
  React.useEffect(() => { setStatesClass(states.length ? 'found-states' : 'no-states') }, [states]);

  const selectCountry = evt => {
    GetStates(e.element, evt.target.value).then(setStates)
  }

  return (
    <div className='StateCountry'>
      <div
        className={`${transparentClasses} a FormInput FormDropdown`} 
        label={OnSchedUtils.Internationalize(e.element, 'setup_resourceSetup_form_country')}
        tooltip="lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar "
      >
        <select 
          name="country"
          className={colorClasses}
          onChange={selectCountry}
        >
          { !countries.length && <option value="" disabled="disabled">{OnSchedUtils.Internationalize(e.element, 'setup_resourceSetup_form_select_country')}</option> }
          { countries.map((country, idx) => <option key={idx} value={country.code}>{country.name}</option>) }
        </select>
      </div>
      <div
        className={`${transparentClasses} a FormInput FormDropdown state-select ${statesClass}`} 
        label={OnSchedUtils.Internationalize(e.element, 'setup_resourceSetup_form_state')}
        tooltip="lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar lorem ipsum dolar "
      >
        <select 
          name="state"
          className={colorClasses}
          disabled={Boolean(!states.length)}
        >
          {!states.length && <option value="" disabled="disabled">{OnSchedUtils.Internationalize(e.element, 'setup_resourceSetup_form_select_state')}</option> }
          { states.map((state, idx) => <option key={idx} value={state.code}>{state.name}</option>) }
        </select>
      </div>
    </div>
  )
}

export default StateCountry;